<script setup lang="ts">
import { ref, computed, onUnmounted } from 'vue';
import { LMap, LTileLayer, LMarker, LPopup } from "@vue-leaflet/vue-leaflet";
import { LatLngExpression, PointExpression } from "leaflet";

import { useStation } from "@/store/station";
import { useLoadingOverlay } from "@/store/overlays/loading-overlay";
import StationDetails from "./station-details.vue";

import { MAP_TILE_URL, DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM } from "@/config";

const station = useStation();
const loading_overlay = useLoadingOverlay();

const zoom = ref<number>(DEFAULT_MAP_ZOOM);
const map_tile_url = ref<string>(MAP_TILE_URL);

const location = computed((): LatLngExpression => {
  return station.location ?? [DEFAULT_MAP_CENTER.lat, DEFAULT_MAP_CENTER.long];
});

onUnmounted(() => loading_overlay.hide());
</script>

<template>
  <v-container class="ma-0 pa-0">
    <l-map
      :center="location as PointExpression"
      :zoom="zoom"
      style="height: calc(100vh - 65px); width: 100vw; overflow: hidden;"
    >
      <l-tile-layer :url="map_tile_url" layer-type="base" name="OpenStreetMap" />
      <!--   add   =>  when the l-marker layer is added to the screen -->
      <!--  ready  =>  when the l-marker is effectively ready         -->
      <l-marker
        :lat-lng="location"
        @add="$nextTick(() => $event.target.openPopup())"
        @ready="loading_overlay.hide"
      >
        <l-popup
          :options="{ closeOnClick: false, maxWidth: 'auto' }"
        >
          <station-details />
        </l-popup>
      </l-marker>
    </l-map>
  </v-container>
</template>

<style scoped>

</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
